<template>
  <div class="card">
    <nuxt-link :to="page.url">
      <div class="card-content">
        <div class="card-info">
          <div class="icon">
            <BookOpenIcon />
          </div>

          <div class="content">
            <h3 v-text="page.title" />
            <div
              class="description"
              v-html="page.description"
            />
          </div>
        </div>
        <ReadMore text="Learn more" />
      </div>
    </nuxt-link>
  </div>
</template>

<script>
import ReadMore from '~/components/Common/ReadMore/ReadMore.vue';
import BookOpenIcon from '~/components/Common/Svg/BookOpenIcon.vue';
export default {
  components: { BookOpenIcon, ReadMore },
  props: {
    page: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import './LeadgenPageCard.scss';
</style>
